import { stringify } from 'query-string';

import { TopicFilterNames } from 'components/TopicFilters/shared';
import getCountryIds from 'helpers/getCountryIds';

export interface IPlaylistTrendURLArgs {
  countryIds?: string[];
  regionIds?: string;
  customerFilter?: TopicFilterNames[];
  entityIds: string;
  playlistIds: number;
  customRegion?: string | string[];
  regionBreakdown?: string;
}

export default function getPlaylistPositionsTrendURL(
  args: IPlaylistTrendURLArgs
): string {
  const {
    countryIds,
    regionIds,
    customerFilter,
    entityIds,
    playlistIds,
    customRegion,
    regionBreakdown,
  } = args;

  const params = stringify({
    countryIds: getCountryIds(countryIds, regionIds, customRegion),
    customerFilter,
    playlistIds,
    ...(regionBreakdown && { regionBreakdown }),
  });

  return `/api/playlist/positions/trend/track/${entityIds}?${params}`;
}
